/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CostBreakdown,
    CostBreakdownFromJSON,
    CostBreakdownToJSON,
    CostBreakdownV2,
    CostBreakdownV2FromJSON,
    CostBreakdownV2ToJSON,
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    OrderItemType,
    OrderItemTypeFromJSON,
    OrderItemTypeToJSON,
} from '../models';

export interface FindBreakdownCostRequest {
    program_id: string;
    currency: string;
    type: OrderItemType;
    value: number;
    include_fee: boolean;
}

export interface FindBreakdownCostV2Request {
    program_id: string;
    product_category_id: string;
    is_fee_included: boolean;
    value: number;
    quantity: number;
    product_id?: string;
    currency?: CurrencyCode;
    language?: string;
}

/**
 * 
 */
export class CostApi extends runtime.BaseAPI {

    /**
     * @deprecated Find the cost breakdown for registration
     */
    async findBreakdownCostRaw(requestParameters: FindBreakdownCostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CostBreakdown>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findBreakdownCost.');
        }

        if (requestParameters.currency === null || requestParameters.currency === undefined) {
            throw new runtime.RequiredError('currency','Required parameter requestParameters.currency was null or undefined when calling findBreakdownCost.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling findBreakdownCost.');
        }

        if (requestParameters.value === null || requestParameters.value === undefined) {
            throw new runtime.RequiredError('value','Required parameter requestParameters.value was null or undefined when calling findBreakdownCost.');
        }

        if (requestParameters.include_fee === null || requestParameters.include_fee === undefined) {
            throw new runtime.RequiredError('include_fee','Required parameter requestParameters.include_fee was null or undefined when calling findBreakdownCost.');
        }

        const queryParameters: any = {};

        if (requestParameters.currency !== undefined) {
            queryParameters['currency'] = requestParameters.currency;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.value !== undefined) {
            queryParameters['value'] = requestParameters.value;
        }

        if (requestParameters.include_fee !== undefined) {
            queryParameters['include_fee'] = requestParameters.include_fee;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/cost`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CostBreakdownFromJSON(jsonValue));
    }

    /**
     * @deprecated Find the cost breakdown for registration
     */
    async findBreakdownCost(requestParameters: FindBreakdownCostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CostBreakdown> {
        const response = await this.findBreakdownCostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find the cost breakdown for registration
     */
    async findBreakdownCostV2Raw(requestParameters: FindBreakdownCostV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CostBreakdownV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findBreakdownCostV2.');
        }

        if (requestParameters.product_category_id === null || requestParameters.product_category_id === undefined) {
            throw new runtime.RequiredError('product_category_id','Required parameter requestParameters.product_category_id was null or undefined when calling findBreakdownCostV2.');
        }

        if (requestParameters.is_fee_included === null || requestParameters.is_fee_included === undefined) {
            throw new runtime.RequiredError('is_fee_included','Required parameter requestParameters.is_fee_included was null or undefined when calling findBreakdownCostV2.');
        }

        if (requestParameters.value === null || requestParameters.value === undefined) {
            throw new runtime.RequiredError('value','Required parameter requestParameters.value was null or undefined when calling findBreakdownCostV2.');
        }

        if (requestParameters.quantity === null || requestParameters.quantity === undefined) {
            throw new runtime.RequiredError('quantity','Required parameter requestParameters.quantity was null or undefined when calling findBreakdownCostV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.product_category_id !== undefined) {
            queryParameters['product_category_id'] = requestParameters.product_category_id;
        }

        if (requestParameters.product_id !== undefined) {
            queryParameters['product_id'] = requestParameters.product_id;
        }

        if (requestParameters.is_fee_included !== undefined) {
            queryParameters['is_fee_included'] = requestParameters.is_fee_included;
        }

        if (requestParameters.currency !== undefined) {
            queryParameters['currency'] = requestParameters.currency;
        }

        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }

        if (requestParameters.value !== undefined) {
            queryParameters['value'] = requestParameters.value;
        }

        if (requestParameters.quantity !== undefined) {
            queryParameters['quantity'] = requestParameters.quantity;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/cost`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CostBreakdownV2FromJSON(jsonValue));
    }

    /**
     * Find the cost breakdown for registration
     */
    async findBreakdownCostV2(requestParameters: FindBreakdownCostV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CostBreakdownV2> {
        const response = await this.findBreakdownCostV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
